import React from "react";
import TrackRelatedContainer from "~/Containers/TrackRelatedContainer";
import TrackImage from "../Elements/Global/TrackImage";
import { Link } from "react-router-dom";
import Card from "react-bootstrap/Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const RelatedTracks = ({ trackId }) => (
  <>
    <TrackRelatedContainer
      trackId={trackId}
      max={3}
      render={({ tracks, loading }) => (
        <div className="sideNavSection">
          <h3>
            <FontAwesomeIcon icon="flag" className="flag" /> Related Tracks
          </h3>
          <div className="relatedSideNav">
            {tracks &&
              tracks.map((track) => {
                return (
                  <Link to={`/${track.id}`} onClick={() => window.gtag('event', 'totd_click', { eventLabel: 'Tracks Related' })}>
                    <Card body className="relatedCard text-left">
                      <span className="relatedThumbnail">
                        <TrackImage styles={{}} width={null} track={track} link={false} />
                      </span>
                      <span>
                        "{track.title}" by {track.artist}
                      </span>
                    </Card>
                  </Link>
                );
              })}
          </div>
        </div>
      )}
    />
  </>
);

export default RelatedTracks;
